import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadFaqMySites } from '@/redux/actions/faq';
import { SUPPORT_URL } from '@/config/urls/supportUrls';
import FaqDefault from '@/components/FrequentlyQuestions/FaqDefault';
import { useResize } from '@/hooks/useResize';


const FaqMySites = ({ className }) => {
  const faq = useSelector(state => state.faq);
  const dispatch = useDispatch();

  const windowRect = useResize();
  const { width } = windowRect;
  const mobile = width < 960;

  useEffect(() => {
    dispatch(loadFaqMySites());
  }, [dispatch]);

  return (
    <FaqDefault
      questions={faq.mySites.questions}
      link={SUPPORT_URL}
      className={className}
      loading={faq.loading}
      height="full"
      roundedBorders={!mobile}
    />
  );
};

export default FaqMySites;
